import i18next from "i18next";
import moment from "moment";
import React from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { GeneralImage, Loader } from "../../../../components";
import { EndPoints } from "../../../../Constants/endpoints";
import DoctorCertificateDetails from "./DoctorCertificateDetails";
import { useGetData } from "../../../../hooks";
import { IServiceProvider } from "../../../../interface/ProfileInterfaces";
import { useTranslation } from "react-i18next";
import EmptyImage from "../../../../assets/images/icons/empty-certificates.svg";

const DoctorCertificates = () => {
  const { t } = useTranslation();
  const { certificateId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const providerId = searchParams.get("provider") ?? "";

  const { data, isLoading } = useGetData<IServiceProvider>(
    EndPoints.GetProviderCertificates,
    {},
    providerId,
  );

  const certificates: any = data?.Data;

  moment.locale(i18next.language);
  const selectedCertificate = certificates?.find(
    (item: any) => item?.Id == certificateId,
  );

  return (
    <>
      {certificateId ? (
        <DoctorCertificateDetails certificate={selectedCertificate} />
      ) : isLoading ? (
        <div className="m-auto h-full w-full">
          <Loader />
        </div>
      ) : certificates?.length > 0 ? (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {certificates?.map(
            (item: any, index: React.Key | null | undefined) => {
              return (
                <div
                  key={index}
                  onClick={() => navigate(`${item?.Id}?provider=${providerId}`)}
                  className="bg-input-field w-full cursor-pointer overflow-hidden rounded-lg border transition-all hover:-translate-y-1 hover:shadow-md"
                >
                  <GeneralImage
                    src={item?.Image}
                    alt={item?.Name}
                    className="!h-[8rem] !w-full object-cover"
                    width="100%"
                  />
                  <div className="flex flex-col gap-1 p-3 text-sm">
                    <div className="flex justify-between font-bold">
                      <span>{item?.Name}</span>
                      <span>{item?.Date}</span>
                    </div>
                    <div className="flex flex-col gap-1 text-secondaryDark">
                      <span className="line-clamp-1">{item?.Authority}</span>
                      <span className="line-clamp-2">{item?.Description}</span>
                    </div>
                  </div>
                </div>
              );
            },
          )}
        </div>
      ) : (
        <div className="flex w-full flex-col items-center justify-center gap-4">
          <img alt="empty" src={EmptyImage} />
          <p className="text-body-text">{t("no_certificate")}</p>
        </div>
      )}
    </>
  );
};

export default DoctorCertificates;
